export default __webpack_public_path__ + "static/media/modelo-plano-acao-icon.ded48907.svg";